const tgdApiBase = process.env.REACT_APP_TGDAPI_SERVER || ''

export async function getAgencyLegalId (agencyName, accessToken) {
  if (!agencyName || !accessToken) return null

  const response = await fetch(`${tgdApiBase}/crm/agencies/${encodeURIComponent(agencyName)}/legal-id`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json'
    }
  })

  if (response.status === 404) {
    return null
  }

  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || 'Erreur lors du chargement du SIREN/SIRET')
  }

  return response.json()
}

export async function saveAgencyLegalId (agencyName, value, accessToken) {
  if (!agencyName || !accessToken) return null

  const response = await fetch(`${tgdApiBase}/crm/agencies/${encodeURIComponent(agencyName)}/legal-id`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ value })
  })

  const body = response.status === 204 ? null : await response.json().catch(() => null)

  if (!response.ok) {
    if (response.status === 409 && body) {
      return { conflict: true, ...body }
    }
    const message = body?.message || 'Erreur lors de l’enregistrement du SIREN/SIRET'
    throw new Error(message)
  }

  return body
}
